import React from 'react';
import { Target, Eye, Heart, CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mission, vision, values } from '../data/mock';

const iconMap = {
  Target: Target,
  Eye: Eye,
  Heart: Heart,
};

const About = () => {
  const mvsData = [
    {
      ...mission,
      Icon: iconMap[mission.icon],
      color: 'amber',
    },
    {
      ...vision,
      Icon: iconMap[vision.icon],
      color: 'blue',
    },
    {
      ...values,
      Icon: iconMap[values.icon],
      color: 'emerald',
    },
  ];

  return (
    <section id="sobre" className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'repeating-linear-gradient(45deg, transparent, transparent 35px, #f59e0b 35px, #f59e0b 36px)',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-500 font-semibold tracking-wider uppercase text-sm">
            Sobre Nós
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mt-4 mb-6">
            Quem Somos
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-8" />
          <p className="text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
            Excelência em engenharia e construção para obras públicas e privadas com
            <span className="text-amber-500 font-semibold"> inovação</span>,
            <span className="text-amber-500 font-semibold"> qualidade</span> e
            <span className="text-amber-500 font-semibold"> responsabilidade</span>.
          </p>
        </div>

        {/* Mission, Vision, Values */}
        <div className="mb-20">
          <h3 className="text-2xl sm:text-3xl font-bold text-white text-center mb-12">
            Missão, Visão <span className="text-amber-500">&</span> Valores
          </h3>

          <div className="grid md:grid-cols-3 gap-8">
            {mvsData.map((item, index) => (
              <Card
                key={index}
                className="bg-slate-800/50 border-slate-700 hover:border-amber-500/50 transition-all duration-300 group hover:transform hover:-translate-y-2"
              >
                <CardContent className="p-8 text-center">
                  <div
                    className={`inline-flex items-center justify-center w-16 h-16 rounded-full mb-6 transition-all duration-300 group-hover:scale-110 ${
                      item.color === 'amber'
                        ? 'bg-amber-500/20 text-amber-500'
                        : item.color === 'blue'
                        ? 'bg-blue-500/20 text-blue-500'
                        : 'bg-emerald-500/20 text-emerald-500'
                    }`}
                  >
                    <item.Icon className="w-8 h-8" />
                  </div>
                  <h4 className="text-xl font-bold text-white mb-4">{item.title}</h4>
                  {item.items ? (
                    <ul className="space-y-3">
                      {item.items.map((value, idx) => (
                        <li key={idx} className="flex items-center justify-center gap-2 text-slate-400">
                          <CheckCircle className="w-4 h-4 text-emerald-500" />
                          <span>{value}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-slate-400 leading-relaxed">{item.description}</p>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { value: '15+', label: 'Anos de Experiência' },
            { value: '200+', label: 'Projetos Concluídos' },
            { value: '50+', label: 'Profissionais' },
            { value: '100%', label: 'Satisfação' },
          ].map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="text-4xl sm:text-5xl font-bold text-amber-500 mb-2 group-hover:scale-110 transition-transform">
                {stat.value}
              </div>
              <div className="text-slate-400 text-sm uppercase tracking-wider">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
